export enum IncidentSeverity {
  Low = 'Low',
  Medium = 'Medium',
  High = 'High',
  Critical = 'Critical'
}

export enum IncidentStatus {
  Investigating = 'Investigating',
  Identified = 'Identified',
  Monitoring = 'Monitoring',
  Resolved = 'Resolved'
}

export interface Incident {
  id: string;
  title: string;
  severity: IncidentSeverity;
  status: IncidentStatus;
  startTime: string;
  endTime?: string;
  description: string;
  serviceId?: string;
  serviceName?: string;
  environmentId?: string;
  environmentName?: string;
  assignedToUserId?: string;
  assignedToUserName?: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreateIncidentData {
  title: string;
  severity: IncidentSeverity;
  description: string;
  serviceId?: string;
  environmentId?: string;
  assignedToUserId?: string;
}

export interface UpdateIncidentData {
  title?: string;
  severity?: IncidentSeverity;
  status?: IncidentStatus;
  description?: string;
  assignedToUserId?: string;
  isResolved?: boolean;
}
